import React, { useEffect, useState } from 'react';
import Responsible from 'src/pages/responsible';
import * as responsiblesApi from "src/apis/responsible";
import * as positionMapsApi from 'src/apis/positionMaps';
import { notification } from 'antd';
import { useTranslation } from 'react-i18next';

/**
 * ResponsibleContainer component - Responsible service layer to call API functions and send fetched data to main page component.
 * @returns {JSX.Element}
 */
function ResponsibleContainer() {
    const [profiles, setProfiles] = useState([]);
    const [positionMaps, setPositionMaps] = useState([]);
    const [responsibles, setResponsibles] = useState([]);
    const [profileOptions, setProfileOptions] = useState([]);

    const { t } = useTranslation();

    useEffect(() => {
        /**
         * refresh all responsibles' and helper data.
         */
        fetchResponsibles();
    }, []);

    /**
     * Fetch data on all responsibles, all existing Position Maps and all existing Profiles.
     */
    const fetchResponsibles = async () => {
        try {
            const allResponsibles = await responsiblesApi.list();
            setResponsibles(allResponsibles.data.result);
    
            const allProfiles = await responsiblesApi.getResponsibleProfiles();
            const formattedProfiles = allProfiles.data.result.map((item) => ({
                value: item,
                label: item,
            }));
            setProfiles(formattedProfiles);
            setProfileOptions(allProfiles.data.result.map((item) => ({
                value: item,
                label: item,
            })));
    
            const allPositionMaps = await positionMapsApi.getPositionMaps();
            const formattedPositionMaps = allPositionMaps.data.result.map((item) => ({
                value: item,
                label: item,
            }));
            setPositionMaps(formattedPositionMaps);
        } catch(err) {
            // notification.error({message: t('errors.responsibles.getData')});
            console.log(err);
        }
    }

    /**
     * Patch a responsible status (active = 'Y' or 'N').
     * @param {string} id - Text for responsibleId 
     * @param {string} status - Text for new status ('Y' or 'N')
     * @returns {Promise<Object>}
     */
    const handlePatchResponsible = (id, status) => {
        return responsiblesApi.patchResponsible(id, { active: status });
    }

    /**
     * Create a responsible.
     * @param {{}} id - Responsible Object
     * @returns {Promise<Object>}
     */
    const handleCreateResponsible = (responsible) => {
        return responsiblesApi.newResponsible(responsible);
    }

    /**
     * Update one responsible's data
     * @param {{}} id - Responsible object
     * @returns {Promise<Object>}
     */
    const handleUpdateResponsible = (responsible) => {
        return responsiblesApi.updateResponsible(responsible);
    }

    return (
        <Responsible
            profiles={profiles}
            positionMaps={positionMaps}
            responsibles={responsibles}
            onPatchResponsible={handlePatchResponsible}
            onCreateResponsible={handleCreateResponsible}
            onUpdateResponsible={handleUpdateResponsible}
            refreshResponsibles={fetchResponsibles}
            profileOptions={profileOptions}
        />
    )
}

export default ResponsibleContainer;
